<template>
	<div class="comp-rise-fallRange" :style="calcCompStyle"></div>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { RISE_FALL_COLOR_CONFIG } from '@/config';
const { proxy } = getCurrentInstance();
import { ZH } from '@/locales';

const props = defineProps({
	size: {
		type: String,
		default: '16'
	},
	type: {
		type: String,
		default: 'up' // up down
	}
});

const getColor = (isCn, type) => {
	return RISE_FALL_COLOR_CONFIG[type][isCn ? 'cn' : 'default'];
};
const calcCompStyle = computed(() => {
	let isCn = proxy.$i18n.locale === ZH;
	const direction = props.type == 'up' ? 'bottom' : 'top';
	const color = getColor(isCn, props.type);

	return `border-left: ${props.size / 2}px solid transparent;
			border-right: ${props.size / 2}px solid transparent;
			border-${direction}: ${props.size}px solid ${color};`;
});
</script>

<style lang="less" scoped>
.comp-rise-fallRange {
	display: inline-block;
	width: 0;
	height: 0;
}
</style>
